// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ComprovanteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /subscriptions/setup-fee/comprovante — o franqueado manda o comprovante do PIX ou da
 * transferência. multipart: franquia_id, valor ("1.500,00"), pago_em (AAAA-MM-DD) e o arquivo
 * em `arquivo` (PDF ou imagem, conferido pelos bytes). Chamado NS 2026-0079, F3.
 */
import { registerContract } from './validate'

export interface SetupFee_ComprovanteInput {
_files: unknown[]
franquia_id?: number
valor?: string
pago_em?: string
}

registerContract('SetupFee_ComprovanteInput', {
  _files:      { type: 'array',   required: true },
  franquia_id: { type: 'number',  required: false },
  valor:       { type: 'string',  required: false },
  pago_em:     { type: 'string',  required: false },
})
